import { render } from "./PriorityData.vue?vue&type=template&id=ffec55c0"
import script from "./PriorityData.vue?vue&type=script&lang=js"
export * from "./PriorityData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__